module.exports = __webpack_public_path__ + "img/noticia-07.84baac67.png";